/**
 * What the learner sees when a unit will not open.
 *
 * A 402 is a plan boundary, not a fault. It used to be an inline banner with no button that stayed
 * on screen after switching course (owner DEV retest 2026-09-24: "It should show proper popup with
 * button to take me to subscription page"). Sol (~/.claude/sol-runs/quiklearn-guardrails/
 * owner-retest2.verdict.md, Q3 A): reuse the app-wide upgrade popup; no persistent banner.
 */
export const unitRefusal = error => {
  const code = String(error?.code || '');
  if (code === 'QUOTA_EXHAUSTED') {
    return {
      paywall: {
        kind: 'quota',
        message: 'You have used this month\u2019s allowance. It renews next month, or upgrade for more.',
      },
    };
  }
  if (code === 'CONTENT_NOT_IN_PLAN' || Number(error?.status) === 402) {
    return {paywall: {kind: 'locked', message: 'Upgrade to open the whole curriculum.'}};
  }
  return {notice: 'We could not open that lesson. Please try again.'};
};
